import React, { useState, useEffect } from 'react';
import './ViewerCounter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';

const ViewerCounter = () => {
  const [viewers, setViewers] = useState(0);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    let socket;
    let reconnectTimeout;

    const connect = () => {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const host = window.location.hostname === 'localhost' ? 'localhost:3001' : window.location.host;

      socket = new WebSocket(`${protocol}//${host}`);

      socket.onopen = () => {
        setIsLive(true);
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === 'viewer_count') {
          setViewers(data.count);
        }
      };

      socket.onclose = () => {
        setIsLive(false);
        reconnectTimeout = setTimeout(connect, 5000);
      };

      socket.onerror = () => {
        socket.close();
      };
    };

    connect();

    return () => {
      if (socket) socket.close();
      if (reconnectTimeout) clearTimeout(reconnectTimeout);
    };
  }, []);

  useEffect(() => {
    if (!isLive) {
      const baseViewers = 1240;
      setViewers(prev => (prev === 0 ? baseViewers : prev));

      const interval = setInterval(() => {
        setViewers(prev => {
          const change = Math.floor(Math.random() * 5) - 2;
          return Math.max(10, prev + change);
        });
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isLive]);

  return (
    <div className={`viewer-counter ${isLive ? 'live' : 'simulated'}`}>
      <div className="live-dot"></div>
      <FontAwesomeIcon icon={faUsers} className="users-icon" />
      <span className="count">{viewers.toLocaleString()}</span>
      <span className="label">{isLive ? 'LIVE NOW' : 'WATCHING NOW'}</span>
    </div>
  );
};

export default ViewerCounter;
